<template>
  <div class="ManageGroupCourseDetails">
      <div class="table-responsive margin-Top-3Perc padding-Left-0px">
        <table class="table table-striped ">
          <thead>
            <tr>
              <th class="text-align-center font-size-15px border-right">Version</th>
              <th class="text-align-center font-size-15px border-right">Elective Course</th>
              <th class="text-align-center font-size-15px border-right">Display Title</th>
              <th class="text-align-center font-size-15px border-right">Display Sub-Title</th>
              <th class="text-align-center font-size-15px border-right">Master Title</th>
              <th class="text-align-center font-size-15px border-right">Master Sub-Title</th>
              <!-- <th class="text-align-center font-size-15px border-right">Created TS</th> -->
              <th class="text-align-center font-size-15px">Action</th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="courseObj in groupCourseMasterListValue" :key="courseObj.GroupCourseMasterId" v-bind:courseObj = "courseObj">
                <td class="text-align-center text-valign-middle border-right col-lg-1">{{getCourseVersion(courseObj)}}</td> 
                <td class="text-align-center text-valign-middle border-right col-lg-1">{{courseObj.IsElective ? 'Yes' : 'No'}}</td>
                <td class="text-align-center text-valign-middle border-right col-lg-3">{{courseObj.DisplayTitle !== undefined && courseObj.DisplayTitle !== 'undefined' && courseObj.DisplayTitle !== null && courseObj.DisplayTitle !== 'null' && courseObj.DisplayTitle !== '' ? courseObj.DisplayTitle : ''}}</td>
                <td class="text-align-center text-valign-middle border-right col-lg-1">{{courseObj.DisplaySubTitle !== undefined && courseObj.DisplaySubTitle !== 'undefined' && courseObj.DisplaySubTitle !== null && courseObj.DisplaySubTitle !== 'null' && courseObj.DisplaySubTitle !== '' ? courseObj.DisplaySubTitle : ''}}</td> 
                <td class="text-align-center text-valign-middle border-right col-lg-3">{{courseObj.CourseTitle}}</td>
                <td class="text-align-center text-valign-middle border-right col-lg-1">{{courseObj.CourseSubTitle}}</td> 
                <!-- <td class="text-align-center text-valign-middle border-right col-lg-1">{{formatAndShowDate(courseObj.CreatedTS)}}</td> -->
                <td class="text-align-center text-valign-middle col-lg-2">
                  <a @click="viewGCMDetails($event,true,courseObj)" class="cursor-pointer"> View </a>|
                  <a @click="editGCMDetails($event,true,courseObj)" class="cursor-pointer"> Edit </a>|
                  <a @click="deleteGroupCourseMaster($event,true,courseObj)" class="cursor-pointer"> Delete </a>
                </td> 
            </tr>
          </tbody>
       </table>
      </div>
    <view-group-course-master v-if="showGroupCourseDetails" v-bind:selectedCourseMasterObj="selectedGroupCourseObj" @closeViewCourse="updateViewCourseOvelray"></view-group-course-master>
    <edit-group-course-master v-if="showEditGroupCourseDetails" v-bind:selectedCourseMasterObj="selectedGroupCourseObj" @closeEditGroupCourse="closeEditGroupCourseOvelray"></edit-group-course-master>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteGrpCourseString" v-bind:postfixString="postDeleteGrpCourseString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteGCM"></confirmation-alert>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
  </div>
</template>

<script>
import { constants } from '@/utils/constants'
import { groupCourseService } from '@/server-util/group-course-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import ViewGroupCourseMaster from '@/components/ViewGroupCourseMasterOverlay'
import EditGroupCourseMaster from '@/components/EditGroupCourseMasterOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  props: ['groupCourseMasterList'],
  data: function () {
    return {
      selectedGroupCourseObj: null,
      showGroupCourseDetails: false,
      showEditGroupCourseDetails: false, // for open edit group course overlay
      showConfirmationBox: false,
      prefixDeleteGrpCourseString: 'Are you sure you want to delete ',
      postDeleteGrpCourseString: '',
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: ''
    }
  },
  computed: {
    groupCourseMasterListValue: {
      get: function () {
        return this.groupCourseMasterList
      }
    }
  },
  methods: {
    getCourseVersion: function (courseObj) {
      if (courseObj.CourseMasterVersion === 'null' || courseObj.CourseMasterVersion === null || courseObj.CourseMasterVersion === '') {
        return ''
      } else {
        return courseObj.CourseMasterVersion
      }
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    viewGCMDetails: function ($event, flagToUpdate, courseObj) {
      // AK: assign selected Group Course Obj
      this.selectedGroupCourseObj = courseObj
      // AK: Open GroupCourse Detail Overlay
      this.showGroupCourseDetails = flagToUpdate
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    // ss:Start Edit Group Course
    editGCMDetails: function ($event, flagToUpdate, courseObj) {
      // AK: assign selected Group Course Obj
      this.selectedGroupCourseObj = courseObj
      // AK: Open GroupCourse Detail Overlay
      this.showEditGroupCourseDetails = flagToUpdate
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    }, // ss:End Edit Group Course
    updateViewCourseOvelray (newValue) {
      // AK: Close View Course master list overlay
      this.showGroupCourseDetails = newValue
      // AK: Enable Background scrolling
      this.$store.state.isOverlayVisible = newValue
    },
    closeEditGroupCourseOvelray (newValue) {
      // AK: Close Edit Course master list overlay
      this.showEditGroupCourseDetails = !newValue.closeOverlay
      // AK: Enable Background scrolling
      this.$store.state.isOverlayVisible = !newValue.closeOverlay
      if (newValue.refreshList) {
        // AK: Refresh GCM List (ManageGroupCourse File)
        this.$emit('refreshGCMList', true)
      }
    },
    deleteGroupCourseMaster: function ($event, flagToUpdate, courseObj) {
      // AK: assign selected Group Course Obj
      this.selectedGroupCourseObj = courseObj
      // AK: Open confirmation Overlay
      this.showConfirmationBox = true
      this.postDeleteGrpCourseString =
        '\'' + this.selectedGroupCourseObj.CourseTitle + '\'?'
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete Group Course overlay
      this.showConfirmationBox = value
    },
    deleteGCM (value) {
      // AK: Hide confirmation Alert
      this.showConfirmationBox = false
      if (value) {
        var storeObj = this.$store
        var _this = this
        if (this.selectedGroupCourseObj !== null) {
          // AK: Start showing spinner to user
          _this.$emit('showSpinner', true)
          groupCourseService
            .deleteGroup(
              storeObj.state.access_token,
              this.selectedGroupCourseObj.GroupCourseMasterId
            )
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  // AK: Hide Spinner after successfully deleting it (ManageGroupCourse File)
                  _this.$emit('showSpinner', false)
                  // AK: Refresh GCM List (ManageGroupCourse File)
                  _this.$emit('refreshGCMList', true)
                } else {
                  // AK: Hide Spinner
                  _this.$emit('showSpinner', false)
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                }
              },
              errorObj => {
                // AK: Hide Spinner
                _this.$emit('showSpinner', false)
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Access Token is NULL hence declined DELETE COURSE MASTER LIST'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'view-group-course-master': ViewGroupCourseMaster,
    'edit-group-course-master': EditGroupCourseMaster,
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox
  },
  name: 'ManageGroupCourseDetails'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.cursor-pointer {
  cursor: pointer;
}
.ManageCourseDetailList {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.text-align-center {
  text-align: center !important;
}
.text-valign-middle {
  vertical-align: middle;
}
.margin-Top-3Perc {
  margin-top: 3% !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Left-1Point4Perc {
  margin-left: 1.4%;
}
a:link {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:visited {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  color: #2c3e50 !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.padding-left-0px{
  padding-left:0%;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
</style>



// WEBPACK FOOTER //
// src/components/ManageGroupCourseDetails.vue